import './style.scss';
import logo from '../../assets/images/logo.png'

function HeaderComponent() {
    return (
        <div>
            <img src={logo} className='img' alt="" />
        </div>
    );
}

export default HeaderComponent;